import React from "react";
import { Form, Card, Collapse, Alert } from "antd";
import RuleBuilderForm from "../RuleBuilderForm";

const { Panel } = Collapse;

const ApprovalRulesSection = ({ factOptions = [] }) => (
  <Card bordered={false} style={{ marginBottom: 24 }}>
    <Form.Item
      name="rules"
      label="Approval Rules"
      valuePropName="value"
      getValueFromEvent={(e) => e}
      rules={[{ required: true, message: "Please define approval rules" }]}
    >
      <RuleBuilderForm factOptions={factOptions} />
    </Form.Item>
    <Collapse style={{ marginTop: 12 }}>
      <Panel header="Live Rule JSON Preview" key="1">
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <pre style={{ background: "#f6f6f6", padding: 12, fontSize: 13 }}>
              {JSON.stringify(getFieldValue("rules") || {}, null, 2)}
            </pre>
          )}
        </Form.Item>
      </Panel>
    </Collapse>
    <Form.Item shouldUpdate noStyle>
      {({ getFieldError }) =>
        getFieldError("rules")?.length > 0 && (
          <Alert
            type="error"
            message={getFieldError("rules").join(", ")}
            style={{ marginTop: 12 }}
          />
        )
      }
    </Form.Item>
  </Card>
);

export default ApprovalRulesSection;
